import { graphql, useStaticQuery } from 'gatsby';

export function usePhotoGalleryInfo() {
  const {
    allPhotoGalleryJson: { nodes: items },
  } = useStaticQuery(graphql`
    query {
      allPhotoGalleryJson {
        nodes {
          desktop {
            childImageSharp {
              gatsbyImageData(placeholder: DOMINANT_COLOR)
            }
          }
          tablet {
            childImageSharp {
              gatsbyImageData(placeholder: DOMINANT_COLOR)
            }
          }
          mobile {
            childImageSharp {
              gatsbyImageData(placeholder: DOMINANT_COLOR)
            }
          }
          popupImg {
            childImageSharp {
              gatsbyImageData(placeholder: DOMINANT_COLOR)
            }
          }
          en {
            title
            description
            date
          }
          de {
            title
            description
            date
          }
          ae {
            title
            description
            date
          }
          signs {
            name
            linkedin
            top
            left
          }
        }
      }
    }
  `);

  return items;
}
